<template>
    <div>
        <div class="form-actions flex justify-between">
            <div class="flex vx-col-action">
                <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChange()" />
                <span class="br-line mr-2 ml-2"></span>
            </div>

            <div class="float-right flex">
                <span class="br-line-long mr-2 ml-2"></span>
                
                <vx-tooltip text="Download list" position="top">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Reset Filters" position="top">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
                </vx-tooltip>
            </div>
        </div>
        
        <div id="grid-loader" class="vx-card vs-con-loading__container">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-material w-100 ag-grid-table"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :components="components"
              :rowData="tableData"
              rowSelection="multiple"
              :enableRangeSelection="true"
              :suppressCopyRowsToClipboard="true"
              :suppressDragLeaveHidesColumns="true"
              :animateRows="false"
              :floatingFilter="true"
              :pagination="true"
              paginationAutoPageSize=true
              :suppressPaginationPanel="true"
              :suppressRowClickSelection="true"
              :statusBar="statusBar"
              :sideBar="sideBar"
              :rowHeight="30"
              :headerHeight="30"
              :floatingFiltersHeight="35"
              @pagination-changed="onPaginationChanged"
              @column-resized="onColumnResized">
            </ag-grid-vue>
            <div class="vx-row py-5">
                <div class="vx-col w-full">
                    <vs-pagination :total="totalPages" :max="maxPageNumbers" class="custom-pagination" v-model="currentPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-enterprise';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss';

import CellRendererEditActions from '@/components/ag-grid-tables/actions/CellRendererEditActions.vue';

export default {
    name: 'UserList',
    components: {
        AgGridVue,
        CellRendererEditActions
    },
    data() {
        return {
            // NOTE: AG-GRID
            gridOptions: {},
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                suppressMovable: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    newRowsAction: 'keep',
                },
            },
            components: {},
            tableData: null,
            autoGroupColumnDef: null,
            maxPageNumbers: 7,
            gridApi: null,
            statusBar: null,
            sideBar: null,
            // NOTE: ACTIONS:
            globalSearchTerm: '',
        }
    },
    beforeMount() {
        // Table Data AXIOS Call
        this.populateTableData();
        // Reset movable columns on mobile
        this.toggleColumnMovable(this.windowWidth);
        (this.columnDefs = [
            {
                headerName: 'Full Name',
                field: 'name',
                filter: 'agSetColumnFilter',
                minWidth: 200,
                width: 200,
                pinned: 'left',
            },
            {
                headerName: 'Email Address',
                field: 'email',
                filter: 'agSetColumnFilter',
                minWidth: 200,
                width: 200,
            },
            {
                headerName: 'User Role',
                field: 'role',
                filter: 'agSetColumnFilter',
                minWidth: 150,
                width: 150,
                cellRenderer: (data) => {
                    if(data.data.role) {
                        // NOTE: Replace hyphens with space & capitalise all first letters
                        return data.data.role.map(x => this.toTitleCase(x.name.split('_').join(' '))).join(', ')
                    }
                },
                valueGetter: (data) => {
                    if(data.data.role) {
                        // NOTE: Replace hyphens with space & capitalise all first letters
                        return data.data.role.map(x => this.toTitleCase(x.name.split('_').join(' '))).join(', ')
                    }
                }
            },
            {
                headerName: 'Actions',
                field: 'actions',
                cellRendererFramework: 'CellRendererEditActions',
                cellRendererParams: (rowData) => ({
                    rowData,
                    triggerEvent: 'openEditUserModal'
                }),
                minWidth: 100,
                width: 100
            },
        ]),
        // Set Grid sidebar
        (this.sideBar = {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true,
                    },
                },
            ],
        });
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        //agigrid loader
        this.gridApi.showLoadingOverlay();
        // Resize to fit columns
        this.sizeColumnsToFit();
        // Reset pinned columns on mobile
        this.toggleColumnPinned(this.windowWidth);
        // Page Download Event
        this.$root.$on('downloadUserList', () => {
            this.gridApi.exportDataAsCsv();
        });
        
        // Refresh list after edit popup is closed
        this.$root.$on('refreshUserList', () => {
            this.populateTableData();
        })
    },
    computed: {
        windowWidth: function () {
            return this.$store.state.windowWidth;
        },
        paginationPageSize() {
            if (this.gridApi) {
                return this.gridApi.paginationGetPageSize();
            } else {
                return 15;
            }
        },
        totalPages() {
            if (this.gridApi) {
                return this.gridApi.paginationGetTotalPages();
            } else {
                return 0;
            }
        },
        scrollbarTag() {
            return this.$store.getters.scrollbarTag;
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            },
        },
    },
    methods: {
        onPaginationChanged() {
            if (this.gridApi) {
                (this.totalRows = this.gridApi.paginationGetRowCount()),
                (this.currentPageSize = this.gridApi.paginationGetPageSize());
            }
        },
        onFilterTextBoxChange() {
            this.gridApi.setQuickFilter(
                document.getElementById('filter-text-box').value
            );
        },
        openLoadingInDiv() {
            this.$vs.loading({
                container: '#div-with-loading',
                scale: 0.8,
            });
        },
        hideLoadingInDiv() {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading');
        },
        toggleColumnMovable(val) {
            if (val <= 576) {
                this.defaultColDef['suppressMovable'] = true;
            } else {
                this.defaultColDef['suppressMovable'] = false;
            }
        },
        toggleColumnPinned(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned('name', null);
            } else {
                this.gridOptions.columnApi.setColumnPinned('name', 'left');
            }
        },
        onColumnResized() {
            this.gridApi.resetRowHeights();
        },
        sizeColumnsToFit() {
            this.gridApi.sizeColumnsToFit();
        },
        downloadData() {
            this.$root.$emit('downloadUserList');
        },
        refreshPageWithFilters() {
            // Reset filters
            this.gridApi.setFilterModel(null);
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
        populateTableData() {
            this.$axiosSecure
            .get('/users')
            .then((response) => {
                this.tableData = response.data;
            })
            .catch((error) => {
                // Error notification
                this.$vs.notify({
                    color: 'danger',
                    title: 'Something went wrong',
                    text: 'Please contact the server admin',
                });
            });

        },
    },
    destroyed() {
        this.$root.$off('refreshUserList');
        this.$root.$off('downloadUserList');
    }
}
</script>